"use strict";exports.toNull=function(){return null};
//# sourceMappingURL=toNull.cjs.map
